import Vue from 'vue'
import LoadScript from 'vue-plugin-load-script'
import CoachRecruit from '@/CoachRecruit'
window._ = require('lodash');
Vue.config.productionTip = false;
Vue.use(LoadScript)
new Vue({
  render: h => h(CoachRecruit)
}).$mount('#app')